export interface ConnectionArgs {
  apiDomain: string,
  locale: string,
  gaID: string,
  log: number,
  userID?: number,
  authkey?: string,
  roomID?: number,
}

const parseConnect = (str: string): ConnectionArgs => {
  const parts = str.split("&");
  let args: Record<string, any> = {};
  for (let p of parts) {
    const a = p.split("=");
    const key = decodeURI(a[0]);
    let value = decodeURI(a[1]);
    args[key] = value;
  }

  let ret: ConnectionArgs = {
    apiDomain: args['apiDomain'],
    locale: args['locale'],
    gaID: args['ga-id'],
    log: args['log'] ? parseInt(args['log']) : 0,
  };

  if (args['userID']) {
    ret.userID = parseInt(args['userID']);
  }
  if (args['authkey']) {
    ret.authkey = args['authkey'];
  }
  if (args['roomID']) {
    ret.roomID = parseInt(args['roomID']);
  }
  return ret;
};

export default parseConnect;